export default "__VITE_ASSET__150793ee__"